import { Formik } from 'formik'
import React from 'react'
import { UseMutateCandidateByIdReturn, candidateDetailsByIdDocument, useCandidateDetailsById, useCandidateTypes, useClearances, useMutateCandidateById } from 'src/queries'
import Form from './Form'
import { dates } from 'src/helpers/displayhelpers'
import { parse } from 'date-fns'
import { MutateCandidateByIdMutation } from 'src/gql/graphql'
import { useInvalidateQueryByDocument } from 'src/hooks/useGraphQL'
import * as Yup from 'yup'

type Values = Parameters<UseMutateCandidateByIdReturn['mutate']>[0]['record']

interface FormContextProps {
  id: string
  toggle: () => void
}

const FormContext: React.FC<FormContextProps> = (props) => {
  const { id, toggle } = props
  const candidate = useCandidateDetailsById(id)
  if (candidate === undefined) {
    throw new Error('Could not load candidate!')
  }
  const clearances = useClearances()
  const candidateTypes = useCandidateTypes()
  const update = useMutateCandidateById()
  const { name, reapply, location, clearance, type } = candidate
  const initialState: Values = {
    name,
    reapply,
    received_on: dates.systemDateOnly(candidate.received_on),
    location,
    clearance,
    type
  }
  const invalidateCandidate = useInvalidateQueryByDocument(candidateDetailsByIdDocument)
  const handleSuccess = (data: MutateCandidateByIdMutation): void => {
    const id = data.cat?.candidate?.updateById?.recordId
    if (typeof id === 'string') {
      void invalidateCandidate({ id })
    }
    toggle()
  }
  const validationSchema = Yup.object().shape({
    name: Yup.object().shape({
      first: Yup.string().required().label('First Name'),
      last: Yup.string().required().label('Last Name')
    })
  })
  return (
    <Formik
      initialValues={initialState}
      onSubmit={async (data) => {
        const { clearance, type } = data
        const record = {
          ...data,
          clearance: clearance === '' ? null : clearance,
          type: type === '' ? null : type,
          received_on: parse(data.received_on, 'yyyy-MM-dd', new Date())
        }
        update.mutate({ id, record }, { onSuccess: handleSuccess })
      }}
      validationSchema={validationSchema}
    >
      {(props) => (
        <Form clearances={clearances} candidateTypes={candidateTypes} toggle={toggle} isLoading={update.isLoading} hasError={update.isError} />
      )}
    </Formik>
  )
}

export default FormContext
